/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import * as Types from '../Types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@apollo/client/react';
const defaultOptions = {} as const;
export type GetConfigQueryVariables = Exact<{ [key: string]: never; }>;


export type GetConfigQuery = { config: { id: string, callAttemptAmount: number, callAttemptInterval: number, colorSchemePrimary: string, colorSchemeSecondary: string, colorSchemeBackground: string, workHoursFrom: string, workHoursUntil: string, incidentReporterOnWatchlist: string, incidentCreatedEmailTemplateId: string, incidentUpdatedEmailTemplateId: string, incidentMentionEmailTemplateId: string, crisisRoomMentionEmailTemplateId: string, taskCreatedEmailTemplateId: string, taskUpdatedEmailTemplateId: string, taskRemindedEmailTemplateId: string, taskDoneEmailTemplateId: string, primaryLanguageId: string, notTranslatableLanguages: string, easyShareUrl: string, conducttrUrl: string, createdAt: unknown, updatedAt: unknown, oidcConfig: { endpoint: string | null, appId: string } | null, incompleteIncident: { deleteAfterMinutes: number | null }, map: { lat: number, lon: number, token: string | null, zoom: number } } };

export type GetDefaultsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetDefaultsQuery = { sources: Array<{ id: string }> };


export const GetConfigDocument = gql`
    query getConfig {
  config {
    id
    oidcConfig {
      endpoint
      appId
    }
    incompleteIncident {
      deleteAfterMinutes
    }
    map {
      lat
      lon
      token
      zoom
    }
    callAttemptAmount
    callAttemptInterval
    colorSchemePrimary
    colorSchemeSecondary
    colorSchemeBackground
    workHoursFrom
    workHoursUntil
    incidentReporterOnWatchlist
    incidentCreatedEmailTemplateId
    incidentUpdatedEmailTemplateId
    incidentMentionEmailTemplateId
    crisisRoomMentionEmailTemplateId
    taskCreatedEmailTemplateId
    taskUpdatedEmailTemplateId
    taskRemindedEmailTemplateId
    taskDoneEmailTemplateId
    primaryLanguageId
    notTranslatableLanguages
    easyShareUrl
    conducttrUrl
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useGetConfigQuery__
 *
 * To run a query within a React component, call `useGetConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetConfigQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetConfigQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetConfigQuery, GetConfigQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetConfigQuery, GetConfigQueryVariables>(GetConfigDocument, options);
      }
export function useGetConfigLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetConfigQuery, GetConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetConfigQuery, GetConfigQueryVariables>(GetConfigDocument, options);
        }
// @ts-ignore
export function useGetConfigSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetConfigQuery, GetConfigQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetConfigQuery, GetConfigQueryVariables>;
export function useGetConfigSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetConfigQuery, GetConfigQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetConfigQuery | undefined, GetConfigQueryVariables>;
export function useGetConfigSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetConfigQuery, GetConfigQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetConfigQuery, GetConfigQueryVariables>(GetConfigDocument, options);
        }
export type GetConfigQueryHookResult = ReturnType<typeof useGetConfigQuery>;
export type GetConfigLazyQueryHookResult = ReturnType<typeof useGetConfigLazyQuery>;
export type GetConfigSuspenseQueryHookResult = ReturnType<typeof useGetConfigSuspenseQuery>;
export type GetConfigQueryResult = Apollo.QueryResult<GetConfigQuery, GetConfigQueryVariables>;
export const GetDefaultsDocument = gql`
    query getDefaults {
  sources(filter: {isDefault: {is: true}}) {
    id
  }
}
    `;

/**
 * __useGetDefaultsQuery__
 *
 * To run a query within a React component, call `useGetDefaultsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDefaultsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDefaultsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetDefaultsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetDefaultsQuery, GetDefaultsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetDefaultsQuery, GetDefaultsQueryVariables>(GetDefaultsDocument, options);
      }
export function useGetDefaultsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetDefaultsQuery, GetDefaultsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetDefaultsQuery, GetDefaultsQueryVariables>(GetDefaultsDocument, options);
        }
// @ts-ignore
export function useGetDefaultsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetDefaultsQuery, GetDefaultsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetDefaultsQuery, GetDefaultsQueryVariables>;
export function useGetDefaultsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetDefaultsQuery, GetDefaultsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetDefaultsQuery | undefined, GetDefaultsQueryVariables>;
export function useGetDefaultsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetDefaultsQuery, GetDefaultsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetDefaultsQuery, GetDefaultsQueryVariables>(GetDefaultsDocument, options);
        }
export type GetDefaultsQueryHookResult = ReturnType<typeof useGetDefaultsQuery>;
export type GetDefaultsLazyQueryHookResult = ReturnType<typeof useGetDefaultsLazyQuery>;
export type GetDefaultsSuspenseQueryHookResult = ReturnType<typeof useGetDefaultsSuspenseQuery>;
export type GetDefaultsQueryResult = Apollo.QueryResult<GetDefaultsQuery, GetDefaultsQueryVariables>;